import { z } from 'zod/v4';

import { DriverIdParameterRuntype } from '../driver';
import { endpoint } from '../http/endpoint';
import { ManufacturingEntityStatusRuntype } from '../sharedManufacturingBackendTypes';
import { ExpensePostRuntype, ExpenseRuntype } from './expensesBackendTypes';

export const expensesEndpoints = {
    'GET /expenses': endpoint({
        description: 'Returns an array of all expenses',
        pathParams: z.undefined(),
        queryParams: z.object({
            active: z.boolean().optional(),
            driver_id: DriverIdParameterRuntype.optional(),
        }),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: z.array(ExpenseRuntype),
        }),
        actionPermission: () => 'CanViewManufacturingTemplates',
    }),
    'GET /expenses/:expenseId': endpoint({
        description: 'Returns an expense',
        pathParams: z.object({ expenseId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: ExpenseRuntype,
        }),
        actionPermission: () => 'CanViewManufacturingTemplates',
    }),

    'POST /expenses': endpoint({
        description: 'Creates an expense',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: ExpensePostRuntype,
        responseBody: z.object({
            data: ExpenseRuntype,
        }),
        actionPermission: () => 'CanCreateManufacturingTemplates',
    }),

    'DELETE /expenses/:expenseId': endpoint({
        description: 'Deletes an expense',
        pathParams: z.object({ expenseId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /expenses', 'GET /expenses/:expenseId'],
        actionPermission: () => 'CanDeleteManufacturingTemplates',
    }),

    'PATCH /expenses/:expenseId': endpoint({
        description: 'Updates an expense',
        pathParams: z.object({ expenseId: z.string() }),
        queryParams: z.undefined(),
        requestBody: ExpensePostRuntype.or(z.object({ status: ManufacturingEntityStatusRuntype })),
        responseBody: z.object({
            data: ExpenseRuntype,
        }),
        invalidates: ['GET /expenses', 'GET /expenses/:expenseId'],
        actionPermission: () => 'CanUpdateManufacturingTemplates',
    }),
};
